import React from 'react'
import { HEADING } from '../../../../components/heading/constants/constants'
import Heading from '../../../../components/heading/Heading'
import Icons from '../../../../components/icons/Icons'
import { VEC_ICON_NAME } from '../../../../components/icons/constants'
import Label from '../../../../components/label/Label'
import TextInput from '../../../../components/input/textinput/TextInput'
import Button from '../../../../components/button/Button'
import { useDispatch, useSelector } from 'react-redux'
import { componentKey } from '../TwoFactorAuthenticationSlice'
import { useEffect } from 'react'
import { disableTFA, getQRCode, verifyTFACode } from '../TwoFactorAuthenticationSaga'
import { useState } from 'react'
import { componentKey as AuthenticationComponentKey } from '../../../authentication/AuthenticationSlice'
import styles from "./EnableTwoFA.styles"
import Loadable from '../../../../components/loadable/Loadable'
import { TFA_STATE, TFA_STATE_MESSAGE_MAP } from '../constant'

export default function EnableTwoFA() {
	const {qrCode, loadingState} = useSelector(state => state[componentKey])
	const {twoFAEnabled} = useSelector(state => state[AuthenticationComponentKey])
	
	const dispatch = useDispatch();
	const [twoFACode, setTwoFACode] = useState('')

	useEffect(()=>{
		dispatch(getQRCode())
	}, [])
	
	const handleInputChange = (e) => {
		const code = e.target.value
		if(code.length <= 6) {
			setTwoFACode(code)
		}
	}

	const handleCodeVerification = () => {
		dispatch(verifyTFACode(twoFACode))
	}

	const handleDisable = () => {
		dispatch(disableTFA())
	}

	return (
		<>
			<div style={styles.mainContainer}>
				<Heading type={HEADING.H1}>Two Factor Authentication</Heading>
				<Loadable currentState={loadingState.state}  loadingStates={TFA_STATE.LOADING} messageMap={TFA_STATE_MESSAGE_MAP} isNewLoadable={true}>
					{ twoFAEnabled ? 
						<>
							<Button style={styles.buttonPadding} onClickCb={handleDisable}>Disable Authentication</Button>
						</> 
						:
						<div style={styles.leftContainer}>
							<Heading type={HEADING.H1}>Scan QR code</Heading>
							<div style={styles.padding}>
								{qrCode ? <img src={qrCode} style={styles.qrImgStyles} /> : <Heading>Unable To Load the QR Code</Heading>}
							</div>
							<Label customStyles={styles.disabledText}>Enter authentication code</Label>
							<TextInput type='number' customStyles={styles.textAlignCenter} placeHolder='XXX - XXX' onChangeCb={handleInputChange} value={twoFACode}/>
							<Button style={styles.buttonPadding} onClickCb={handleCodeVerification}>Enable Authentication</Button>
						</div>
					}
				</Loadable>
			</div>
			<div style={styles.rightContainer}>
				<Icons familyName={'vec'} iconName={VEC_ICON_NAME.TWO_FA_VECTOR}/>
				<Heading type={HEADING.H1}>Stronger security for your Tax1099.com account</Heading>
				{ twoFAEnabled ?
					<>
						<Label customStyles={styles.text}>1. <b>Enhanced Security:</b> 2FA adds an extra layer of protection, reducing risks from compromised passwords and unauthorized access attempts.</Label>
						<Label customStyles={styles.text}>2. <b>Protection Against Password Theft:</b> 2FA acts as a safety net, preventing breaches even if passwords are stolen.</Label>
						<Label customStyles={styles.text}>3. <b>Safeguarding Personal Information:</b> 2FA secures sensitive data, maintaining privacy and blocking unauthorized access.</Label>
						<Label customStyles={styles.text}>4. <b>Peace of Mind:</b>  2FA boosts confidence, assuring safety against cyberattacks and identity theft, fostering a sense of security.</Label>
					
					</>
					:
					<>
						<Label customStyles={styles.text}>1. You will need to install a suitable authenticator app on your smartphone or tablet. Some examples of such apps include <b>Google Authenticator, Duo, TOTP, and Twilio Authy.</b></Label>
						<Label customStyles={styles.text}>2. Within the authenticator app, locate and tap the <b>"Add" button.</b></Label>
						<Label customStyles={styles.text}>3. Continuing within the authenticator app, select the <b>"Scan Barcode" option.</b></Label>
						<Label customStyles={styles.text}>4. Now, return to the Tax1099 platform and use your authenticator app to scan the provided QR code. This will link your authenticator app to your Tax1099.</Label>
					</> 
				}
			</div>
		</>
	)
}